/**
 * Единый источник часового пояса камеры (ТЗ №2 §10, решение Q4):
 * item.display_timezone → root response.display_timezone →
 * CameraResponse.display_timezone → undefined (fallback formatInTimezone).
 * Никаких вычислений по географии/браузеру/профилю.
 */
export const resolveCameraTimezone = ({ item, response, camera } = {}) =>
  item?.display_timezone || response?.display_timezone || camera?.display_timezone || undefined;

/** Подпись для одной камеры (ТЗ №2 §10.2): IANA-имя, не offset. */
export const describeSingleTimezone = (timeZone) => (timeZone ? `Часовой пояс ${timeZone}` : '');
